<template>
  <div>
    <button class="secondary" @click="$router.push('/profil')">
      Tilbake til profil
    </button>
    <div class="profile-edit">
      <h1>Endre din profil</h1>
      <h3>Bosted:</h3>
      <p>
        <input type="text" v-model="city" />
      </p>
      <h3>Telefon:</h3>
      <p>
        <input type="number" v-model="telephone" />
      </p>
      <h3>Om meg:</h3>
      <p>
        <textarea v-model="userBio"></textarea>
      </p>
      <p>
        <span @click="patchUserInfo">
          <LinkButton
            :text="isWorking ? 'Arbeider...' : 'Lagre'"
            :disabled="isWorking"
          />
        </span>
      </p>
      <p class="success" v-if="savedSuccessful">Endringene er lagret!</p>
      <p class="error" v-if="savedFailed">
        Det skjedde en feil, prøv igjen senere.
      </p>
      <p
        v-if="!isWorking && !savedSuccessful && !savedFailed"
        style="height: 1em"
      ></p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProfileEdit",
  data() {
    return {
      userId: null,
      city: null,
      userBio: null,
      telephone: null,

      savedSuccessful: false,
      savedFailed: false,
      isWorking: false,
    };
  },
  mounted() {
    this.getUserId();
  },
  methods: {
    async patchUserInfo() {
      const token = await this.$auth.getTokenSilently();
      this.isWorking = true;
      let axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
        },
      };

      let patchData = {
        userId: this.userId,
        city: this.city,
        telephone: this.telephone,
        userBio: this.userBio,
      };

      await axios
        .patch(
          `${this.$store.state.baseApiUrl}/candidate/${this.$auth.user.sub}`,
          patchData,
          axiosConfig
        )
        .then(() => {
          this.savedSuccessful = true;
          this.savedFailed = false;
          this.$router.push("/profil");
        })
        .catch(() => {
          this.savedSuccessful = false;
          this.savedFailed = true;
          this.isWorking = false;
        });
    },
    async getUserId() {
      const token = await this.$auth.getTokenSilently();
      let axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
        },
      };
      axios
        .get(
          `${this.$store.state.baseApiUrl}/candidate/${this.$auth.user.sub}`,
          axiosConfig
        )
        .then((response) => {
          this.userId = response.data.id;
          this.city = response.data.city;
          this.telephone = response.data.telephone;
          this.userBio = response.data.userBio;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/*
 * Alt i CSS-en er hacka sammen på kort tid, bare å endre på hvis du vil
*/

.profile-edit {
  text-align: center;
}

.profile-edit input,
.profile-edit textarea,
.profile-edit button,
.profile-edit a {
  width: 50%;
  max-width: var(--content-width);
  box-sizing: border-box;
}

@media only screen and (max-width: 750px) {
  input,
  textarea,
  button,
  a {
    width: 100%;
    max-width: 90%;
    margin: 0 1em;
  }
}

.success {
  color: green;
}

.error {
  color: red;
}
</style>